/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../../_metronic/partials/widgets'
import { useAuth, UserModel } from '../../modules/auth'
import { Link, useNavigate } from 'react-router-dom'
import { companySession } from '../../master/api'
import { setProjectSession, FullPageLoader } from '../../component/helper'
import { useState } from 'react'

import { AllReportList } from '../../master/reports/allReport/allReportList'

import { getProjectByCompany } from '../../master/telecalling/api'
import { PasswordUpdate } from '../../component/password-update'
import moment from 'moment';

const CurrentLogButton = () => (
  <Link to='/current-log' target='_blank' rel='noopener noreferrer' className='btn btn-sm btn-primary fw-bold'>
    Current Log
  </Link>
)

const DashboardPage: FC = () => (


  <>
    {/* begin::Row */}
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* begin::Col */}
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget20
          className='h-md-50 mb-5 mb-xl-10'
          description='Active Projects'
          color='#F1416C'
          img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />
        <CardsWidget7
          className='h-md-50 mb-5 mb-xl-10'
          description='Professionals'
          icon={false}
          stats={357}
          labelColor='dark'
          textColor='gray-300'
        />
      </div>
      {/* end::Col */}

      {/* begin::Col */}
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget17 className='h-md-50 mb-5 mb-xl-10' />
        <ListsWidget26 className='h-lg-50' />
      </div>
      {/* end::Col */}

      {/* begin::Col */}
      <div className='col-xxl-6'>
        <EngageWidget10 className='h-md-100' />
      </div>
      {/* end::Col */}
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gx-5 gx-xl-10'>
      {/* begin::Col */}
      <div className='col-xxl-6 mb-5 mb-xl-10'>
        {/* <app-new-charts-widget8 cssclassName="h-xl-100" chartHeight="275px" [chartHeightNumber]="275"></app-new-charts-widget8> */}
      </div>
      {/* end::Col */}

      {/* begin::Col */}
      <div className='col-xxl-6 mb-5 mb-xl-10'>
        {/* <app-cards-widget18 cssclassName="h-xl-100" image="./assets/media/stock/600x600/img-65.jpg"></app-cards-widget18> */}
      </div>
      {/* end::Col */}
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 gx-xl-8'>
      <div className='col-xxl-4'>
        <ListsWidget3 className='card-xxl-stretch mb-xl-3' />
      </div>
      <div className='col-xl-8'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        {/* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
      </div>
    </div>
    {/* end::Row */}

    <div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>
      <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const { currentUser } = useAuth()
  const user: UserModel = currentUser as UserModel
  const navigate = useNavigate();
  console.log('currentUser new setup', currentUser)
  const intl = useIntl()
  const [loading, setLoading] = useState(false);

  const [filterOption, setFilterOption] = useState<Array<{
    id: number;
    uuid: string;
    ref_key: string;
    secret_key: string | null;
    company_id: number;
    project_name: string;
    project_nick_name: string;
    email: string;
    poc_name: string;
    poc_designation: string;
    poc_email: string | null;
    phone: string;
    mobile: string;
    whatsapp_number: string | null;
    pan_check_required: number;
    address1: string | null;
    address2: string | null;
    address3: string | null;
    landmark: string | null;
    city: string | null;
    pincode: string | null;
    pincode_id: string | null;
    district: string | null;
    state: string | null;
    country_id: string | null;
    small_logo: string | null;
    medium_logo: string | null;
    large_logo: string | null;
    banner_image1: string | null;
    banner_image2: string | null;
    banner_image3: string | null;
    banner_image4: string | null;
    mapping_type: number;
    calling_DID: string | null;
    calling_language_code: string | null;
    calling_data_url: string | null;
    calling_data_push_url: string | null;
    status: number;
    kyc_upi_enable: number | null;
    kyc_bank_enable: number | null;
    kyc_pan_enable: number | null;
    remarks: string | null;
    in_house_credit: string;
    outside_redeem_elig_required: string;
    outside_redeem_push_required: string;
    is_redemption: number;
    earning_type: string;
    registration_mode: string;
    is_nominee_required: number;
    reg_approval_required: string;
    created_by: number | null;
    updated_by: number | null;
    created_at: string;
    updated_at: string;
    order_count?: string | number;
  }>>([]);
  const [selectedProject, setSelectedProject] = useState<{ id: string; name: string } | null>(null);
  // const [reportList, setReportList] = useState<Array<{ name?: string; description?: string; type?: string; lastGenerated?: string; status?: string }>>([]);
  const [reportLoading, setReportLoading] = useState(false);

  const handleFilterChange = async (projectObj?: any) => {
    setReportLoading(true);
    setSelectedProject(projectObj);
    setReportLoading(false);
  };


  useEffect(() => {
    if (user?.company_id) {

      getProjectByCompany({ company_id: user?.company_id })
        .then((d) => {
          setFilterOption(d || []);
        })
        .catch((error) => {
          console.error('Error fetching projects:', error);

        });
    }
  }, [user?.company_id]);



  useEffect(() => {


    // If user role is 'npp project', redirect to project url
    const redirectToProject = async () => {
      if (user?.accesses?.role === "npp project") {
        const projectId = Number(user?.accesses?.project_id);
        if (!projectId) {
          return;
        }
        setLoading(true);
        try {
          const data = await companySession(0, projectId);

          if (data?.code === 1 && data?.data?.project) {
            setProjectSession(data.data.project);
            navigate('/apps/company-management/project_scheme', { replace: true });
          } else {
            setLoading(false);
            console.error('not switched');
          }
        } catch (error) {
          setLoading(false);
          console.error('Error during project session switch:', error);
        }
      }
    };

    redirectToProject();
  }, [user, navigate]);
  // Check if user's updated_at is not today


  const isNotToday = user?.updated_at && !moment(user?.updated_at).isSame(moment(), 'day');

  if (isNotToday && user?.password_changed === 1) {
    return <PasswordUpdate show={true} onClose={() => { }} />;
  }
  return (
    <>
      {loading && <FullPageLoader />}
      {user?.accesses?.role === "Team" ? (
        <>
          <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
          <div className="container-fluid">
            {/* Project Selection Filter */}
            <div className='row mb-8'>
              <div className='col-lg-12'>
                <div className='card'>
                  <div className='card-body'>
                    <div className='row mb-5'>
                      <div className='col-lg-12'>
                        <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 ">
                          <KTSVG path='/media/icons/duotune/general/gen045.svg' className='svg-icon-3x svg-icon-warning me-5' />
                          <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                            <div className="mb-3 mb-md-0 fw-semibold">
                              <h5 className="text-gray-900 fw-semibold">Welcome! , This page provides access to various reports and download options.</h5>

                              <div className="fs-7 text-gray-700 pe-7">
                                <b>Report By Days</b>: You can download reports for the <b>Last 7 Days</b>, <b>Last 15 Days</b>, <b>Last 30 Days</b>, or <b>All</b>.
                                <b>Today Report</b> is also available. Please ensure you have the necessary permissions to download or view these reports.
                              </div>
                            </div>
                            <CurrentLogButton />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Reports List */}

                    {reportLoading ? (
                      <div className='d-flex justify-content-center align-items-center py-10'>
                        <div className='spinner-border text-primary' role='status'>
                          <span className='visually-hidden'>Loading...</span>
                        </div>
                        <span className='ms-3 text-muted'>Loading reports...</span>
                      </div>)
                      : (
                        // No Project Selected State
                        <div className='row'>
                          <div className='col-lg-12'>
                            <div className='card shadow-sm'>
                              <div className='card-header min-height-39px border-0'>
                                <div className='card-title'>
                                  <h5 className='card-title text-gray-900 fw-semibold'>Reports</h5>
                                </div>
                                <div className='card-toolbar'>
                                  <div className='d-flex justify-content-end align-items-center' data-kt-user-table-toolbar='base'>

                                    <div className='w-200px me-3'>
                                      <select
                                        className='form-select form-select-solid'
                                        data-control='select2'
                                        data-placeholder='Select Project'
                                        data-allow-clear='true'
                                        onChange={(e) => {
                                          console.log('e.target.value', e.target.value);
                                          const selectedOption = filterOption.find(project => Number(project?.id) === Number(e.target.value));
                                          console.log('selectedOption', selectedOption);
                                          handleFilterChange(selectedOption);
                                        }}
                                        value={selectedProject?.id || ''}
                                      >
                                        <option value=''>Select Project</option>

                                        {filterOption?.length > 0 ? (
                                          filterOption.map((project) => {
                                            return (
                                              <option key={project?.id} value={project?.id}>
                                                {project?.project_name} {project?.order_count && `(${project.order_count})`}
                                              </option>
                                            );
                                          })
                                        ) : (
                                          <option value='' disabled>No projects available - Check console for API errors</option>
                                        )}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {selectedProject ? (
                                <div className='mb-5'><AllReportList /></div>
                              ) : (
                                <div className='card-body text-center py-15'>
                                  <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3x svg-icon-muted mb-5' />
                                  <div className='text-gray-900 fw-bold fs-3 mb-3'>Select a Project</div>
                                  <div className='text-muted fs-6'>Please select a project from the dropdown above to view available reports and analytics.</div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                  </div>
                </div>
              </div>
            </div>

          </div>

        </>
      ) : (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
          <div className='d-flex justify-content-end mb-5'>
            <CurrentLogButton />
          </div>
          <DashboardPage />
        </>
      )}
    </>
  )
}

export { DashboardWrapper }
